import { cva, type VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const headlineVariants = cva(
  "font-['TT Commons'] font-semibold tracking-normal",
  {
    variants: {
      variant: {
        100: "font-bold text-[42px] leading-[56px]",
        200: "text-4xl leading-[48px]",
        300: "text-2xl",
        400: "text-xl",
        500: "text-lg leading-[24px]",
      },
      color: {
        primary: "text-v2-primary",
        secondary: "text-v2-secondary",
      },
    },
    defaultVariants: {
      variant: 500,
      color: "primary",
    },
  },
);

type HeadlineProps = VariantProps<typeof headlineVariants> & {
  children: React.ReactNode;
  className?: string;
};

export const Headline = ({
  variant,
  color,
  className,
  children,
}: HeadlineProps) => {
  return (
    <div className={twMerge(headlineVariants({ variant, color }), className)}>
      {children}
    </div>
  );
};
